export const stories = [
  {
    title: "Si Boru Pareme",
    description: "Legenda putri cantik yang menjadi danau",
    content:
      "Cerita tentang seorang putri yang sangat cantik bernama Boru Pareme. Karena kesombongannya, ia dikutuk menjadi danau yang indah.",
    moral: "Kesombongan akan membawa kehancuran",
    region: "Tapanuli Utara",
    image: "https://regalsprings.co.id/wp-content/uploads/2023/05/Danau-Toba.png",
    references: [
      {
        title: "Artikel Kompasiana yang membahas legenda dan sisi barat Danau Toba",
        url: "https://www.kompasiana.com/mtf3lix5tr/61adc67062a70438191fe142/menyingkap-keindahan-sisi-barat-danau-toba?page=all&page_images=17&utm_source=chatgpt.com",
      }
    ],
  },
  {
    title: "Sampuraga",
    description: "Kisah raja yang bijaksana",
    content:
      "Raja Sampuraga dikenal sebagai pemimpin yang adil dan bijaksana. Ia selalu mengutamakan kesejahteraan rakyatnya.",
    moral: "Kepemimpinan yang baik membutuhkan kebijaksanaan",
    region: "Simalungun",
    image: "https://cdn.rri.co.id/berita/96/images/1683810295928-Screenshot_20230511_195251/1683810295928-Screenshot_20230511_195251.JPG",
    references: [
      {
        title: "Artikel Superlive yang menceritakan legenda dan daya tarik kolam air panas",
        url: "https://superlive.id/superadventure/artikel/place-gears/kolam-air-panas-sampuraga-legenda-dan-daya-tarik-di-dalamnya?",
      }
    ],
  },
  {
    title: "Si Boru Saniang Naga",
    description: "Putri naga yang baik hati",
    content:
      "Kisah putri naga yang turun ke bumi untuk membantu manusia yang sedang kesulitan.",
    moral: "Kebaikan hati akan selalu dibalas",
    region: "Toba",
    image: "https://pdbifiles.nos.jkt-1.neo.id/files/2024/07/03/batakologi_IMG1276_1720023783.JPG",
    references: [
      {
        title: "Boru Saniang Naga - Kompasiana",
        url: "https://www.kompasiana.com/mtf3lix5tr/5bda98a9bde5753c0921e527/boru-saniangnaga-dewi-air-orang-batak?page=all&page_images=1&utm_source=chatgpt.com",
      },
      {
        title: "Boruspati ni Tano - Wikipedia",
        url: "https://en.wikipedia.org/wiki/Boraspati_ni_Tano?utm_source=chatgpt.com",
      },
    ],
  },
];
